'use strict';

exports.__esModule = true;
var SEARCH_TAB_CHANGED = exports.SEARCH_TAB_CHANGED = 'SEARCH_BAR_TABS:SEARCH_TAB_CHANGED';
var OPEN_APPOINTMENTS_SEARCH_DROPDOWN = exports.OPEN_APPOINTMENTS_SEARCH_DROPDOWN = 'SEARCH_BAR_TABS:OPEN_APPOINTMENTS_SEARCH_DROPDOWN';
var OPEN_APPOINTMENTS_LOCATION_DROPDOWN = exports.OPEN_APPOINTMENTS_LOCATION_DROPDOWN = 'SEARCH_BAR_TABS:OPEN_APPOINTMENTS_LOCATION_DROPDOWN';
var OPEN_HEALTH_CHECKS_SEARCH_DROPDOWN = exports.OPEN_HEALTH_CHECKS_SEARCH_DROPDOWN = 'SEARCH_BAR_TABS:OPEN_HEALTH_CHECKS_SEARCH_DROPDOWN';
var OPEN_HEALTH_CHECKS_LOCATION_DROPDOWN = exports.OPEN_HEALTH_CHECKS_LOCATION_DROPDOWN = 'SEARCH_BAR_TABS:OPEN_HEALTH_CHECKS_LOCATION_DROPDOWN';
var OPEN_SCANS_SEARCH_DROPDOWN = exports.OPEN_SCANS_SEARCH_DROPDOWN = 'SEARCH_BAR_TABS:OPEN_SCANS_SEARCH_DROPDOWN';
var OPEN_SCANS_LOCATION_DROPDOWN = exports.OPEN_SCANS_LOCATION_DROPDOWN = 'SEARCH_BAR_TABS:OPEN_SCANS_LOCATION_DROPDOWN';
var SET_LOCATION_INPUT_FIELD = exports.SET_LOCATION_INPUT_FIELD = 'SEARCH_BAR_TABS:SET_LOCATION_INPUT_FIELD';

var SearchBarTabsActions = {
	selectedSearchTabChanged: function selectedSearchTabChanged(selectedTab) {
		return {
			type: SEARCH_TAB_CHANGED,
			selectedTab: selectedTab
		};
	},
	openAppointmentsSearchDropdown: function openAppointmentsSearchDropdown() {
		return {
			type: OPEN_APPOINTMENTS_SEARCH_DROPDOWN
		};
	},
	openHealthChecksSearchDropdown: function openHealthChecksSearchDropdown() {
		return {
			type: OPEN_HEALTH_CHECKS_SEARCH_DROPDOWN
		};
	},
	openScansSearchDropdown: function openScansSearchDropdown() {
		return {
			type: OPEN_SCANS_SEARCH_DROPDOWN
		};
	},
	openScansLocationDropdown: function openScansLocationDropdown() {
		return {
			type: OPEN_SCANS_LOCATION_DROPDOWN
		};
	},
	openHealthChecksLocationDropdown: function openHealthChecksLocationDropdown() {
		return {
			type: OPEN_HEALTH_CHECKS_LOCATION_DROPDOWN
		};
	},
	openAppointmentsLocationDropdown: function openAppointmentsLocationDropdown() {
		return {
			type: OPEN_APPOINTMENTS_LOCATION_DROPDOWN
		};
	},
	setLocationInputField: function setLocationInputField(inputField) {
		return {
			type: SET_LOCATION_INPUT_FIELD,
			payload: {
				locationInputField: inputField
			}
		};
	}
};

exports.default = SearchBarTabsActions;


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/search-bar-tabs.js